import { Button } from "react-bootstrap"

type CButtonProps = {
    children?:any
    onClick?:() => void
}

const CButton:React.FC<CButtonProps> = ({onClick, children}) => {
    return (
        <Button 
        className="btn-outline-primary "
        variant="outline-primary" 
        onClick={ (e) => onClick!()}>
        {children}
    </Button>
    )
}

export default CButton